import qs from 'qs';
import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { InternalToolsOrg, OrgRequestParams } from '../../../../shared/InternalTools/orgs';

export const getInternalToolsOrgsQueryKey = (params: OrgRequestParams): QueryKey =>
  ['internal-tools', 'orgs', params];

function getInternalToolsOrgs(params: OrgRequestParams) {
  return get<InternalToolsOrg[]>(`/api/internal-tools/orgs?${qs.stringify(params)}`);
}

/**
 * Fetches the filtered list of organizations for the Internal Tools page.
 *
 * @param {OrgRequestParams} params - The serialized filter params.
 * @param {boolean} enabled - Whether to run the query. Pass `false` to keep the list empty
 * until the admin has entered at least one filter.
 */
export function useGetInternalToolsOrgs(params: OrgRequestParams, enabled: boolean) {
  return useQuery<InternalToolsOrg[]>({
    queryKey: getInternalToolsOrgsQueryKey(params),
    queryFn: () => getInternalToolsOrgs(params),
    enabled,
  });
}
